import { Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import DemandaEmbarque from '../../../../../../domains/DemandaEmbarque';
import PrazoCarregamento from '../../../../../../domains/PrazoCarregamento';
import { CustomModal, SelectContainer } from './styles';

const { Option } = Select;

const freqOptions = DemandaEmbarque.getOptions();

const prazoOptions = PrazoCarregamento.getOptions();

const CarregamentoModal = ({
  visible,
  setVisible,
  freqCarregamento,
  setFreqCarregamento,
  prazoCarregamento,
  setPrazoCarregamento,
}) => {
  const [confirmLoading, setConfirmLoading] = useState();
  const [freq, setFreq] = useState(freqCarregamento);
  const [prazo, setPrazo] = useState(prazoCarregamento);

  const handleOk = async () => {
    setConfirmLoading(true);

    setVisible(false);
    setFreqCarregamento(freq);
    setPrazoCarregamento(prazo);

    setConfirmLoading(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <CustomModal
      title="Carregamento e inclusão de motoristas"
      visible={visible}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
    >
      <SelectContainer>
        <p>Carregamento</p>
        <Select
          defaultValue={freqCarregamento.name}
          style={{ width: '50%' }}
          onChange={value =>
            setFreq(freqOptions.find(freqOption => freqOption.value === value))
          }
        >
          {freqOptions.map(freqOption => (
            <Option key={freqOption.value} value={freqOption.value}>
              {freqOption.name}
            </Option>
          ))}
        </Select>
      </SelectContainer>

      <SelectContainer>
        <p>Permitir inclusão de motoristas</p>
        <Select
          defaultValue={prazoCarregamento.name}
          style={{ width: '50%' }}
          onChange={value =>
            setPrazo(
              prazoOptions.find(prazoOption => prazoOption.value === value)
            )
          }
        >
          {prazoOptions.map(prazoOption => (
            <Option key={prazoOption.value} value={prazoOption.value}>
              {prazoOption.name}
            </Option>
          ))}
        </Select>
        <p>
          <span>
            Será considerado apenas os dias de carregamento definidos{' '}
          </span>
        </p>
      </SelectContainer>
    </CustomModal>
  );
};

CarregamentoModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  freqCarregamento: PropTypes.shape({
    value: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    embarque: PropTypes.arrayOf(
      PropTypes.shape({
        ocorreEmbarque: PropTypes.bool,
        diaSemana: PropTypes.number,
      })
    ).isRequired,
  }).isRequired,
  setFreqCarregamento: PropTypes.func.isRequired,
  prazoCarregamento: PropTypes.shape({
    value: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  setPrazoCarregamento: PropTypes.func.isRequired,
};

export default CarregamentoModal;
